import React from "react";
import { Box, Grid, Typography } from "@material-ui/core";
import AdminLogo from "../../Assets/Svg/Camroo_Horizontal_White.svg";
import { useStyles } from "./Login/LoginStyles";

const LogoHead = () => {
  const classes = useStyles();

  return (
    <>
      <Grid item className={`${classes.displayFlex1} ${classes.width100}`}>
        <Box
          style={{
            display: "inline-flex",
            justifyContent: "center",
            alignItems: "center",
            marginBottom: 8,
          }}
        >
          <img
            src={AdminLogo}
            alt="Camroo"
            height={90}
            style={{ width: "auto", objectFit: "contain" }}
          />
        </Box>
      </Grid>
      <Grid item className={`${classes.displayFlex1} ${classes.width100}`}>
        <Typography className={classes.heading2}>
          Welcome to Admin Platform
        </Typography>
      </Grid>
    </>
  );
};

export default LogoHead;
